import { App_Url_New } from "../common/static";

export function handleQuoteBuyNowNavigation(
  navigate: (to: string, options?: { state?: Record<string, unknown> }) => void,
  data?: unknown,
  quoteDetails?: unknown,
  personalDetails?: unknown
) {
  const targetPath = App_Url_New?.CommonPageUrl?.actions?.uploadDocuments;

  if (!targetPath) {
    console.error("Navigation error: upload documents path is undefined.");
    return;
  }

  navigate(targetPath, {
    state: {
      quoteData: data,
      quoteDetails,
      personalDetails,
      reset: true,
    },
  });
}
